import { CardWithDynamicBackgroundProps } from '@comfama/comfama-ui-react';
import { richTextToPlainText } from '../../../../utils/richTextToPlainText';


interface IProgramacionCardsProps {
    heading: string;
    description: string;
    tagline: string | undefined;
    cards: [
        {
            id: string;
            description: string;
            icon: string;
            ctaAction: string;
            ctaLabel: string;
            variant: CardWithDynamicBackgroundProps['variant'];
        },
    ];
}
const variants = ['tertiary', 'primary', 'yellow', 'turquoise'];
function programacionCardsAdapter(data: any): IProgramacionCardsProps {
    return {
        heading: data.tituloGeneral ?? '',
        description: richTextToPlainText(JSON.parse(data.descripcion.raw) ?? ''),
        tagline: data.etiquetasArticulo?.[0] ?? '',
        cards: data.referenciaPlantillaContenido?.map(
            (card: any, idx: number) => ({
                id: card.tituloBanner.replace(' ', '-').toLowerCase() + idx,
                description: card.tituloBanner ?? '',
                icon: card?.imagenPrincipal?.[0]?.file?.url ?? '',
                ctaAction: card.redireccionBoton ?? '',
                ctaLabel: card.tituloBoton ?? '',
                variant: variants[idx % variants.length],
            }),
        ),
    };
}
export default programacionCardsAdapter;
